import React, { useState, useEffect, useRef } from 'react'

// Deps
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
// import arrayMove from 'array-move'

// Functions
import accountDetail from 'functions/reorder-array'

// Partials
import Btn from 'views/shared/partials/btn'
import Loader from 'views/shared/partials/loader'

// Services
import companyServices from 'services/company'

const SortableItem = SortableElement(({item}) => {
	return (
		<li className="company-payment-types-order-list-item">
			<div className="item-content">
				{item.api_name} ({item.payment_type.name})
			</div>
		</li>
	)
});
 
const SortableList = SortableContainer(({items}) => {
	return (
		<ul className="section order-list">
			{items.map((item, index) => (
				<SortableItem key={`item-${item.id}`} index={index} item={item} />
			))}
		</ul>
	);
});

const CompanyPaymentTypeOrderModal = ({ className, closeBtn, close, onSuccess, groupID, ...props}) => {
	const _mounted = useRef(false);

	const [data, setData] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		_mounted.current = true;
		let listParams = { page: 1, per_page: 9999 };

		if(groupID) {
			listParams.store_code = groupID;
		}

		companyServices.listPaymentTypes(listParams).then((payload) => {
			if(_mounted.current) {
				setData(payload.paymentTypes)
			}
		})

		return () => {
			_mounted.current = false;
		}
	}, [groupID]);

	const submit = () => {
		setSubmitting(true);
		companyServices.reorderPaymentTypes(data.map((item) => { return {id: item.id}; }), groupID).then(() => {
			if(onSuccess) {
				onSuccess();
			}
			close();
		}).finally(() => {
			setSubmitting(false);
		})
	}

	const sort = (sortData) => {
		setData(accountDetail(data, sortData.oldIndex, sortData.newIndex));
	}

	return (
		<div className={className}>
			<div className="modal-header dark">
				<h1 className="header-title">Ödeme Aracı Sıralaması</h1>
				{closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={!data} />

				{data &&
					<SortableList
						lockAxis="y"
						items={data}
						lockToContainerEdges={true}
						onSortEnd={sort} />
				}
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || !data}
					onClick={submit}>
					Sıralamayı Kaydet
				</Btn>
			</div>
		</div>
	)
}

CompanyPaymentTypeOrderModal.defaultProps = {
	className: '',
	containerClass: 'modal-company-payment-type-order mobile-full',
	name: 'company-payment-type-order',
	groupID: false,
}

export default CompanyPaymentTypeOrderModal